import React from "react";
import OrdersTab from "./OrdersTab";
import StateFilter from './filters/OrderStateFilter';
import AllFilter from './filters/All';
import OnReceivingPointFilter from './filters/OnReceivingPointFilter';
import { OnFactoryFilter, OnIntermediatePointFilter, filterNames } from './filters/DcDepartmentsFilters';

import { 
    states, 
    doneStates,
    urgentStates, 
    deliveryStates, 
    deliveryReceivingPointStates, 
    operatorAllStates, 
    receivingPointOrdersStates, 
    processedStates, 
    receivingPointEditStates } from '../../constants/orderStates';
import * as dcDepartmentTypes from "../../constants/dcDepartmentTypes";
import * as permissions from "../../constants/permissions";

const allStatesSelector = () => {
    if (permissions.getRole() == permissions.RECEPTION_POINT) {
        return states.filter(s => receivingPointEditStates.includes(s.Id));
    }
    return states.filter(s => operatorAllStates.includes(s.Id));
}

const receivingPointOrdersStatesSelector = () => {
    return states.filter(s => receivingPointOrdersStates.includes(s.Id));
}

const DeliveryFilter = (props) => <StateFilter states={states.filter(s => deliveryStates.includes(s.Id))} {...props} />;
const DeliveryReceivingPointFilter = (props) => <OnReceivingPointFilter stateSelector={() => states.filter(s => deliveryReceivingPointStates.includes(s.Id))} {...props} />;
const UrgentFilter = (props) => <StateFilter states={states.filter(s => urgentStates.includes(s.Id))} {...props} />;
const ProcessedFilter = (props) => <StateFilter states={states.filter(s => processedStates.includes(s.Id))} {...props} />;
const AllOrdersFilter = (props) => <AllFilter stateSelector={allStatesSelector} {...props} />
const ReceivingPointOrdersFilter = (props) => <OnReceivingPointFilter stateSelector={receivingPointOrdersStatesSelector} {...props} />
const DoneFilter = (props) => <StateFilter states={states.filter(s => doneStates.includes(s.Id))} {...props} />

export const UrgentTab = () => <OrdersTab filterComponent={UrgentFilter} filterName='ordersFilter' />;
export const DeliveryTab = () => <OrdersTab filterComponent={DeliveryFilter} filterName='ordersFilter' />;
export const DeliveryReceivingPointTab = () => <OrdersTab filterComponent={DeliveryReceivingPointFilter} filterName='onReceivingPoint' />
export const DoneTab = () => <OrdersTab filterComponent={DoneFilter} filterName='ordersFilter' />;
export const ReceptionPointProcessed = () => <OrdersTab />;
export const AllTab = () => <OrdersTab filterComponent={AllOrdersFilter} stateSelector={allStatesSelector} filterName='allOrdersFilter' />
export const ProcessedTab = () => <OrdersTab filterComponent={ProcessedFilter} filterName='ordersFilter' />
export const InProcessTab = () => <OrdersTab filterComponent={OnFactoryFilter} filterName={filterNames.onFactory} dcTypes={dcDepartmentTypes.factories} />
export const OnIntermediatePointTab = () => <OrdersTab filterComponent={OnIntermediatePointFilter} filterName={filterNames.onIntermediatePoint} dcTypes={dcDepartmentTypes.acceptPoints} />
export const OnReceivingPoint = () => <OrdersTab filterComponent={OnReceivingPointFilter} filterName='onReceivingPoint' />
export const ReceptionPointOrders = () => <OrdersTab filterComponent={ReceivingPointOrdersFilter} filterName='onReceivingPoint' />


// WEBPACK FOOTER //
// ./src/components/orders/Tabs.jsx